import type { Ref } from 'react';
import { useTranslations } from '@ifixit/i18n/hooks';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@ifixit/ui/components/input-otp';
import { REGEXP_ONLY_DIGITS } from 'input-otp';

interface CodeInputProps {
   value: string;
   onChange: (value: string) => void;
   inputId?: string;
   autoFocus?: boolean;
   ref?: Ref<HTMLInputElement>;
}

export const CodeInput = ({
   value,
   onChange,
   inputId = 'code-input',
   autoFocus = false,
   ref,
}: CodeInputProps) => {
   const t = useTranslations('Login');
   const descriptionId = `${inputId}-description`;
   const labelId = `${inputId}-label`;

   return (
      <div className="w-full flex flex-col items-start gap-2">
         <div role="group" aria-labelledby={labelId} aria-describedby={descriptionId}>
            <label id={labelId} className="text-sm font-medium block text-start mb-2">
               {t('sixDigitCode')}
            </label>
            <InputOTP
               ref={ref}
               id={inputId}
               maxLength={6}
               value={value}
               onChange={onChange}
               pattern={REGEXP_ONLY_DIGITS}
               autoComplete="one-time-code"
               autoFocus={autoFocus}
            >
               <InputOTPGroup>
                  <InputOTPSlot index={0} />
                  <InputOTPSlot index={1} />
                  <InputOTPSlot index={2} />
                  <InputOTPSlot index={3} />
                  <InputOTPSlot index={4} />
                  <InputOTPSlot index={5} />
               </InputOTPGroup>
            </InputOTP>
         </div>
         <p id={descriptionId} className="text-sm text-gray-500">
            {t('enterSixDigitCodeReceived')}
         </p>
      </div>
   );
};
